module.exports = __webpack_public_path__ + "img/price-1.b3a4d0ed.png";